import AdminClient from '../client/AdminClient';

class RealEstateInvestmentService {
    static async update(investmentId, session, tracked_real_estate_investment) {
        return AdminClient.put(`/v1/admin/tracked_real_estate_investments/${investmentId}`, session, {tracked_real_estate_investment: tracked_real_estate_investment});
    }

    static async delete(realEstateInvestmentId, session) {
        return AdminClient.delete(`/v1/admin/tracked_real_estate_investments/${realEstateInvestmentId}`, session);
    }
}
export default RealEstateInvestmentService;